export default __webpack_public_path__ + "static/media/EastfieldDistributionCentre.9e4639ab.jpg";